import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Watchlist from "./pages/Watchlist";
import LikedMovies from "./pages/LikedMovies";
import Header from "./components/Header";
import MovieDetails from "./pages/MovieDetails";
import { AuthProvider } from "./context/AuthContext"; // Import AuthProvider
import Profile from "./pages/Profile";
import Signin from "./pages/Signin";
import SearchResultsPage from "./pages/SearchResultsPage";
import GenreMovies from "./pages/GenreMovies";

function App() {
    return (
        <div className="App">
            <Router>
                <AuthProvider>
                    <Header />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route
                            path="/movies/page/:pageNumber"
                            element={<Home />}
                        />
                        <Route path="/watchlist" element={<Watchlist />} />
                        <Route path="/likedmovies" element={<LikedMovies />} />
                        <Route
                            path="/genre/:genreId/page/:pageNumber"
                            element={<GenreMovies />}
                        />
                        <Route
                            path="/movie/:movieId"
                            element={<MovieDetails />}
                        />
                        <Route
                            path="/movies/search/:searchTerm/page/:pageNumber"
                            element={<SearchResultsPage />}
                        />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/signin" element={<Signin />} />
                    </Routes>
                </AuthProvider>
            </Router>
        </div>
    );
}

export default App;
